interface GAEventParams {
  context?: string
  subcontext?: string
  isRelishMember?: string
}

/**
 * @description Track events in Google Analytics.
 */
export function useAnalytics() {
  function trackEvent(eventName: string, eventParams?: GAEventParams): void {
    try {
      // include isRelishMember (boolean formatted as string)
      const orderingStore = useOrderingStore()
      if (!eventParams) {
        eventParams = {}
      }
      eventParams.isRelishMember = orderingStore.user.isSignedIn.toString()

      useTrackEvent(eventName, eventParams)
    } catch (error: any) {
      console.error(`Error tracking event: ${eventName}`, error.message)
    }
  }
  function trackOrderingAppEvent(eventName: string, eventParams?: Record<string, any>): void {
    useTrackEvent(eventName, eventParams)
  }
  return { trackEvent, trackOrderingAppEvent }
}

export function gaEventAccordionExpanded(): void {
  const { trackEvent } = useAnalytics()

  trackEvent('accordion_expanded')
}

export function gaEventCateringClicked(context: 'cta' | 'details'): void {
  const { trackEvent } = useAnalytics()

  trackEvent('catering_clicked', { context })
}

export function gaEventGroupBookingClicked(context: 'cta' | 'details'): void {
  const { trackEvent } = useAnalytics()

  trackEvent('group_booking_clicked', { context })
}

export function gaEventLocalMattersVote(context: 'coles'): void {
  const { trackEvent } = useAnalytics()

  trackEvent('local_matters_vote', { context })
}

export function gaEventLocalMattersClaim(context: 'coles'): void {
  const { trackEvent } = useAnalytics()

  trackEvent('local_matters_claim', { context })
}
